module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"featureChip":{"more":"+ {n} more feature | + {n} more features"}}}')
  delete Component.options._Ctor
}
